import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useIsEntityVp } from "./entityVpContext";
import { canAccessCountryLifecycle } from "./permissions";
import { LifecycleName } from "./roles";
import { useRoles } from "./useRoles";

type Props = {
  lifecycle: LifecycleName;
  children: ReactNode;
};

export const RequireCountryLifecycleRole = ({ lifecycle, children }: Props) => {
  const { id } = useParams<{ id?: string }>();
  const roles = useRoles();
  const isEntityVp = useIsEntityVp();

  if (!canAccessCountryLifecycle(roles, lifecycle, isEntityVp)) {
    return (
      <Navigate to={id ? `/countries/country/${id}` : "/countries"} replace />
    );
  }

  return children;
};
